import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { isEmbedded } from "@app/shared/resources/embedded-mobile-checker";
import { phoneValid } from "@app/shared/validators/phoneValid";

@Component({
    selector: "clare-text-input",
    templateUrl: "./clare-text-input.component.html",
    styleUrls: ["./clare-text-input.component.scss"],
})
export class ClareTextInputComponent implements OnInit {
    @Input() metaData: any;
    @Input() theForm: FormGroup;
    @Input() isLoading: boolean;
    @Input() enableRetry: boolean;
    @Input() notRequired: string;
    @Input() isFullWidthField = false;
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public formControl: AbstractControl;

    get isEmbedded() {
        return isEmbedded();
    }

    // Readonly switch on click does not work in embedded mode
    public isReadonly = !this.isEmbedded;

    regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                return null;
            }
            const valid = regex.test(control.value);
            return valid ? null : error;
        };
    }

    getErrors() {
        if (this.formControl.errors) {
            const errors = Object.entries(this.formControl.errors);
            if (errors.length) {
                const printableErrors = [];
                for (const error of errors) {
                    if (error[0] !== "required") {
                        printableErrors.push(error[1]);
                    } else {
                        printableErrors.push(
                            `Please enter a valid ${(this.metaData.friendlyName || this.metaData.name || "").toLowerCase()}.`
                        );
                    }
                }

                return printableErrors.join(" ");
            }
        }

        return "";
    }

    onBlurHandler() {
        this.onBlur.emit();
    }

    checkReadonly() {
        return this.isReadonly && this.metaData.type === "password";
    }

    turnOffReadonly(event) {
        this.isReadonly = false;
        event.target.focus();
    }

    ngOnInit() {
        const validators = [];

        if (this.metaData) {
            // notRequired is false, i.e., isRequired
            if (!coerceBooleanProperty(this.notRequired)) {
                validators.push(Validators.required);
            }

            if (this.metaData.patternMatch) {
                this.metaData.patternMatch.forEach(pattern => {
                    if (pattern.name === "validPhone") {
                        validators.push(phoneValid);
                    } else {
                        validators.push(
                            this.regexValidator(new RegExp(pattern.regex), {
                                [pattern.name]: pattern.errorString,
                            })
                        );
                    }
                });
            }

            this.formControl = this.theForm.controls[this.metaData.inputName];
            this.formControl.setValidators(validators);

            if (this.formControl.value) {
                this.onBlurHandler();
            }
        }
    }
}
